var map = {
	"./en/apps.json": [
		95627,
		[
			5627
		]
	],
	"./en/auto.json": [
		13516,
		[
			3516
		]
	],
	"./en/chat.json": [
		85645,
		[
			5645
		]
	],
	"./en/comptabilite.json": [
		82806,
		[
			2806
		]
	],
	"./en/customers.json": [
		56712,
		[
			6712
		]
	],
	"./en/dashboard.json": [
		26061,
		[
			6061
		]
	],
	"./en/devis.json": [
		55702,
		[
			5702
		]
	],
	"./en/documents.json": [
		69355,
		[
			9355
		]
	],
	"./en/employees.json": [
		11780,
		[
			1780
		]
	],
	"./en/expenses.json": [
		92118,
		[
			2118
		]
	],
	"./en/invoice.json": [
		27938,
		[
			7938
		]
	],
	"./en/layout.json": [
		86801,
		[
			6801
		]
	],
	"./en/navigation.json": [
		42165,
		[
			2165
		]
	],
	"./en/notification.json": [
		27016,
		[
			7016
		]
	],
	"./en/reports.json": [
		45394,
		[
			5394
		]
	],
	"./en/sales.json": [
		60313,
		[
			313
		]
	],
	"./en/sessions.json": [
		9234,
		[
			9234
		]
	],
	"./en/settings.json": [
		42974,
		[
			2974
		]
	],
	"./fr/apps.json": [
		82562,
		[
			2562
		]
	],
	"./fr/auto.json": [
		73601,
		[
			3601
		]
	],
	"./fr/chat.json": [
		69292,
		[
			9292
		]
	],
	"./fr/comptabilite.json": [
		65279,
		[
			5279
		]
	],
	"./fr/customers.json": [
		16003,
		[
			6003
		]
	],
	"./fr/dashboard.json": [
		24054,
		[
			4054
		]
	],
	"./fr/devis.json": [
		92797,
		[
			2797
		]
	],
	"./fr/documents.json": [
		96220,
		[
			6220
		]
	],
	"./fr/employees.json": [
		78807,
		[
			8807
		]
	],
	"./fr/expenses.json": [
		4347,
		[
			4347
		]
	],
	"./fr/invoice.json": [
		46941,
		[
			6941
		]
	],
	"./fr/layout.json": [
		55092,
		[
			5092
		]
	],
	"./fr/navigation.json": [
		84952,
		[
			4952
		]
	],
	"./fr/notification.json": [
		9085,
		[
			9085
		]
	],
	"./fr/reports.json": [
		47029,
		[
			7029
		]
	],
	"./fr/sales.json": [
		92154,
		[
			2154
		]
	],
	"./fr/sessions.json": [
		69919,
		[
			9919
		]
	],
	"./fr/settings.json": [
		10967,
		[
			967
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72096;
module.exports = webpackAsyncContext;